import React from "react";
import { useLocation } from "react-router-dom";
import { COMMS_MODULE_NAME, MODULE_NAME } from "../moduleName";
import {
  AppBar,
  AppBarProps,
} from "@ofqual/portal-components/components/SecondaryAppBar";

const SEARCH_STATE_KEY = "search";

type ModuleAppBarProps = Omit<AppBarProps, "moduleName">;

export const ModuleAppBar: React.FC<ModuleAppBarProps> = ({
  children,
  breadcrumbs = [],
}) => {
  // for the a module, we want the root breadcrumb to link to retain the main list search params.
  const { state } = useLocation<{ [SEARCH_STATE_KEY]?: string }>();

  const rootBreadcrumb = {
    label: "Inbox - Contact AO",
    to: `${state?.[SEARCH_STATE_KEY] || ""}`,
    dataTest: "breadcrumb-inbox",
  };

  return (
    <AppBar
      moduleName={`${COMMS_MODULE_NAME}/${MODULE_NAME}`}
      breadcrumbs={[rootBreadcrumb, ...breadcrumbs]}
    >
      {children}
    </AppBar>
  );
};
